import React, { useMemo, useState } from 'react';
import { ThemeProvider } from '../helpers/ThemeContext';
import { FullBleedContainer, TopLevelContainer, Row, Column } from '@xo-union/tk-component-grid';
import FullscreenTopbar from './FullscreenTopbar';
import ThemeSelection from '../Themes/Selection';
import { OnboardingContext, STEPS } from '../OnboardingContext';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import styles from './index.scss';
import { useMobileMedia } from '@xo-union/tk-ui-breakpoints';
import OnboardingForm from '../OnboardingForm';

const WeddingDetails: React.FC = () => {
  const location = useLocation();
  const isIncomingFromAd = (queryString.parse(location.search) || {})['utm_medium'] === 'cpa';
  const wrapperStyles = isIncomingFromAd ? styles.adWrapper : styles.noAdWrapper;
  const media = useMobileMedia();
  const [currentStep, setCurrentStep] = useState(STEPS.BASIC_INFO);
  const { onboardingType } = React.useContext(OnboardingContext);
  // If we're not on the basic info step, and we're on mobile, don't show the theme selection
  const ThemeSelectionHelper = useMemo(
    () => (currentStep !== STEPS.BASIC_INFO && media.yes ? null : <ThemeSelection />),
    [currentStep, media]
  );

  return (
    <div className={styles.container}>
      <ThemeProvider>
        <FullscreenTopbar />
        <div className={wrapperStyles}>
          <FullBleedContainer>
            <TopLevelContainer>
              <Row>
                <Column xs="12">
                  <div className={onboardingType === 'AI' ? styles.innerContainerAI : styles.innerContainer}>
                    {/* Hide the theme preview and selection for AI onboarding */}
                    {onboardingType !== 'AI' && ThemeSelectionHelper}
                    <OnboardingForm setCurrentStep={setCurrentStep} />
                  </div>
                </Column>
              </Row>
            </TopLevelContainer>
          </FullBleedContainer>
        </div>
      </ThemeProvider>
    </div>
  );
};

export default WeddingDetails;
